import {formsApiHostName} from "../endpoint";
import {defaultHeaders} from "../headers";

export const deleteFormById = async (id) => {
  try {
    const result = await fetch(`${formsApiHostName}/forms/${id}`, {
      method: "DELETE",
      headers: {
        ...defaultHeaders,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    });
    return {
      hasSuccess: result.status === 200,
      data: await result.json(),
    };
  } catch (err) {
    return {
      hasSuccess: false,
      data: err.message,
    };
  }
};
